const routes = {
  HOME: "/",
  PLANS: "/plans",
  BLOGS: "/blogs",
  BLOG: "/blog",
  CONTACT: "/contact",
  LEDGER: "/ledger",
  DOCKET: "/docket",
  BITE: "/bite",
  REGISTER: "/register",
  SUCCESSFUL: "/successful",
  ONBOARDING: "/onboarding",
};

export default routes;
